const isUpperManagement = (user: any) => {
  if (user?.roles?.includes('user') && user?.group?.name === 'UpperManagement') {
    return true;
  }

  return false;
};

export default isUpperManagement;
